export enum ROUTE {
  DASHBOARD = "/dashboard",
  DOCUMENTS = "/documents",
  HOME = "/",
  LOGIN = "/login",
  REFUNDS = "/refunds",
  REGISTER = "/register",
  SETTINGS = "/settings",
}
